import { equal } from '@ember/object/computed';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { SignaturePreference as SignaturePreferenceProto, DigitalSignatureSettings as DigitalSignatureSettingsProto, PaperSignatureSettings as PaperSignatureSettingsProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/common/signature';
import Enum from '@square/dashboard-utilities/utils/enum';
import { computed } from '@ember/object';
export const DigitalSignatureCondition = new Enum(Object.keys(DigitalSignatureSettingsProto.CollectSignatureCondition));
export const SignaturePreference = new Enum(Object.keys(SignaturePreferenceProto));
export const TipType = new Enum(Object.keys(PaperSignatureSettingsProto.TipType));
export const DigitalSignatureSettings = ProtoBaseModel.extend({
  condition: attr(DigitalSignatureCondition),
  purchasesOverThreshold: equal('condition', DigitalSignatureCondition.PURCHASES_OVER_THRESHOLD),
  purchasesOfAnyAmount: equal('condition', DigitalSignatureCondition.ALL_PURCHASES)
});
export const PaperSignatureSettings = ProtoBaseModel.extend({
  tipType: attr(TipType),
  printCustomerCopy: attr(Boolean),
  includeItemDetails: attr(Boolean),
  useQuickTips: equal('tipType', TipType.QUICK_TIP),
  printAdditionalAuthSlip: attr(Boolean)
});
export default ProtoBaseModel.extend({
  collectSignature: attr(Boolean),
  digitalSignatureSettings: attr(DigitalSignatureSettings),
  paperSignatureSettings: attr(PaperSignatureSettings),
  signaturePreference: attr(SignaturePreference),
  showReceiptScreen: attr(Boolean),
  isDigitalSignature: equal('signaturePreference', SignaturePreference.DIGITAL),
  isPaperSignature: equal('signaturePreference', SignaturePreference.PAPER),
  kioskDisplayValueTranslationKey: computed('collectSignature', function () {
    return this.collectSignature ? 'business.devices.profiles.v2.settings.checkout.kioskSignature.displayValue.on' : 'business.devices.profiles.v2.settings.checkout.kioskSignature.displayValue.off';
  })
});